import { Skeleton } from '@rtkwlf/fenrir-react';

import styles from './security-focus-timeline-item-loading.module.css';

export const SecurityFocusTimelineItemLoading: React.FunctionComponent = () => {
  return (
    <div
      className={styles['sft-item-loading']}
      data-testid="security-focus-timeline-item-loading"
    >
      <Skeleton className={styles['skeleton']} />
      <div className={styles['sft-item-loading-grid']}>
        <Skeleton className={styles['skeleton']} />
        <Skeleton className={styles['skeleton']} />
        <Skeleton className={styles['skeleton']} />
        <Skeleton className={styles['skeleton']} />
      </div>
    </div>
  );
};
